import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function ChartJsLineChart({ data, options, height, onPointClick }) {
  const handleClick = (event, elements) => {
    if (!elements?.length || !onPointClick) return;
    onPointClick(elements[0].index);
  };

  const mergedOptions = {
    ...options,
    onClick: handleClick,
  };

  return (
    <Line
      data={data}
      options={mergedOptions}
      height={height}
    />
  );
}
